export enum COMMAND_APPEARANCE {
  DEFAULT = 'default',
}
